export const MARKUP_SECTION_TYPE = 'markup-section'
export const LIST_SECTION_TYPE = 'list-section'
export const MARKUP_TYPE = 'markup'
export const MARKER_TYPE = 'marker'
export const POST_TYPE = 'post'
export const LIST_ITEM_TYPE = 'list-item'
export const CARD_TYPE = 'card-section'
export const IMAGE_SECTION_TYPE = 'image-section'
export const ATOM_TYPE = 'atom'

export const enum Type {
  MARKUP_SECTION = 'markup-section',
  LIST_SECTION = 'list-section',
  MARKUP = 'markup',
  MARKER = 'marker',
  POST = 'post',
  LIST_ITEM = 'list-item',
  CARD = 'card-section',
  IMAGE_SECTION = 'image-section',
  ATOM = 'atom',
}
